export function getHostname() {
  return window.location.hostname;
}

export function getHostAndDomain() {
  return `${window.location.hostname}/${window.location.pathname.split('/')[1]}`;
}
